import React from 'react';

const LoadingAnimation = () => (
  <div className="spinner">
    <div className="bounce1" />
    <div className="bounce2" />
    <div className="bounce3" />
  </div>
);

export default LoadingAnimation;
